import Logger from 'core/utils/Logger'

import { IProductTreeItem } from '../models/productTreeItem'

export const deduplicateProductTreeItems = (
  items: readonly IProductTreeItem[]
): IProductTreeItem[] => {
  const seenUniqueIds = new Set<string>()
  const duplicateUniqueIds = new Set<string>()

  const deduplicatedItems = items.filter((item) => {
    // Preserve legacy entries without UniqueId; do not treat them all as duplicates.
    if (!item.UniqueId) return true
    if (seenUniqueIds.has(item.UniqueId)) {
      duplicateUniqueIds.add(item.UniqueId)
      return false
    }

    seenUniqueIds.add(item.UniqueId)
    return true
  })

  if (duplicateUniqueIds.size > 0) {
    Logger.error(
      `JBPProductTree data error: duplicate UniqueIds ${[...duplicateUniqueIds].sort().join(', ')}; ${items.length} records, ${deduplicatedItems.length} unique.`
    )
  }

  return deduplicatedItems
}
